import { Component, input } from '@angular/core';
import { BOProduct } from '@boels/models';
import { ProductCodeComponent } from '../product-code/product-code.component';
import { ProductNewComponent } from '../product-new/product-new.component';
import { ProductOneCallComponent } from '../product-one-call/product-one-call.component';
import { SafeCheckPipe } from '@boels/helpers';

@Component({
  selector: 'boels-product-identifier',
  templateUrl: './product-identifier.component.html',
  styleUrls: ['./product-identifier.component.scss'],
  imports: [
    ProductCodeComponent,
    ProductNewComponent,
    ProductOneCallComponent,
    SafeCheckPipe,
  ],
})
export class ProductIdentifierComponent {
  product = input.required<BOProduct>();
  displayCodeDescription = input<boolean>(true);
}
